<template>
  <div>
    <el-card class="mb-1" style="box-shadow:none">
      <h5 v-if="baseInfo.scmName">{{ baseInfo.scmName }}</h5>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div style="height: 29px;line-height: 29px;overflow: hidden;">
            <span style="font-size: 14px; color: #606266">
              No：{{ baseInfo.hxPurchaseNo || 'New' }}
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                !baseInfo.hxPurchaseStatus
                  ? ''
                  : baseInfo.hxPurchaseStatus === 'N'
                  ? 'primary'
                  : baseInfo.hxPurchaseStatus === 'Y'
                  ? 'success'
                  : baseInfo.hxPurchaseStatus === 'D'
                  ? 'danger'
                  : 'warning'
              "
            >
              {{ baseInfo.v_hxPurchaseStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <el-tag
              v-if="baseInfo.v_hxSkuSalesChannel"
              size="mini"
              :type="
                baseInfo.hxSkuSalesChannel === 'H'
                  ? 'success'
                  : baseInfo.hxSkuSalesChannel === 'V'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_hxSkuSalesChannel }}
            </el-tag>
            <el-divider direction="vertical" />
            <span style="font-size: 14px; color: #606266">
              Update：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyDate || '--' }}
            </span>
          </div>
        </div>
        <div class="switch-tabs_wrappers">
          <div class="switch-tabs">
            <div
              v-for="item in switchTabs"
              :key="item.value"
              class="switch-tabs_items"
              :class="{
                active: item.value === activeName,
                disabled: item.disabled,
              }"
              @click="!item.disabled ? (activeName = item.value) : () => {}"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'" style="box-shadow:none">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :hxPurchaseCode="hxPurchaseCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-between mb-2 mt-2">
          <div>
            <span style="font-size: 14px; color: #606266">
              Create：{{ baseInfo.createByName || '--' }} at
              {{ baseInfo.createDate || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Submit：{{ baseInfo.submitByName || '--' }} at
              {{ baseInfo.submitTime || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Review：{{ baseInfo.reviewByName || '--' }} at
              {{ baseInfo.reviewTime || '--' }}
            </span>
          </div>
          <div>
            <el-button
              v-if="!disabled"
              type="primary"
              size="small"
              @click="$refs.editForm.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </el-card>
      <el-card v-show="activeName == 'goods'" style="box-shadow:none">
        <SkuTable
          :disabled="disabled"
          :hxPurchaseCode="hxPurchaseCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
      <el-card v-show="activeName == 'batch'" style="box-shadow:none">
        <BatchTable
          :disabled="disabled"
          :hxPurchaseCode="hxPurchaseCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
import BatchTable from '../components/batch-table'
export default {
  name: 'ecom-hxBiz-hxFtyPurchaseOrder-detail',
  components: { EditForm, SkuTable, BatchTable },
  data() {
    return {
      baseInfo: {},
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    hxPurchaseCode() {
      return this.params.hxPurchaseCode
    },
    switchTabs() {
      return [
        { label: '基本信息', value: 'base' },
        { label: '订单产品', value: 'goods', disabled: !this.hxPurchaseCode },
        { label: '样品需求', value: 'sample', disabled: !this.hxPurchaseCode },
        { label: '出货批次', value: 'batch', disabled: !this.hxPurchaseCode },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
